export const planDefinitions = {
  trial: {
    id: 'trial',
    name: 'Free Trial',
    description: 'Full access during your trial, then convert to the Founders plan',
    price: 0,
    billingPeriod: null,
    trialDuration: 30, // days
    popular: false,
    type: 'trial',
    features: {
      // Core features
      coreFeatures: [
        'Full campaign analytics',
        'Performance reporting',
        'Basic automation',
        'Email support',
      ],
      // Usage limits
      limits: {
        // trackedAsins: 10,
        // searchTerms: 10,
        campaigns: 'unlimited',
        users: 1,
      },
      // Included add-ons (none for trial)
      includedAddOns: [],
    },
    restrictions: [
      'Trial expires after 30 days',
      'Limited to 10 tracked ASINs',
      'Limited to 10 search terms',
    ],
    callToAction: 'Start Free Trial',
    highlight: 'Most Popular',
  },

  trialExpired: {
    id: 'trialExpired',
    name: 'Trial Expired',
    description: 'Your 30-day trial has ended. Subscribe to the Founders plan to restore full access.',
    price: 0,
    billingPeriod: null,
    trialDuration: 30, // days
    popular: false,
    type: 'expired',
    features: {
      // Core features
      coreFeatures: [
        'Full campaign analytics',
        'Performance reporting',
        'Basic automation',
        'Email support',
      ],
      // Usage limits
      limits: {
        campaigns: 'unlimited',
        users: 1,
      },
      // Included add-ons (none while unsubscribed)
      includedAddOns: [],
    },
    restrictions: [
      'Trial ended — data updates are paused',
      'Limited to 10 tracked ASINs',
      'Limited to 10 search terms',
    ],
    callToAction: 'Subscribe Now',
    highlight: null,
  },

  basic: {
    id: 'basic',
    name: 'Founders Plan',
    description:
      '$45/month + 1% of your Amazon PPC ad spend. Your price is locked for as long as you stay subscribed. Future add-ons are priced separately.',
    price: 45,
    billingPeriod: 'month',
    popular: true,
    type: 'paid',
    features: {
      // Core features
      coreFeatures: [
        'Full campaign analytics',
        'Advanced reporting',
        // 'Basic automation',
        'Priority email support',
        'Usage-based metering',
      ],
      // Usage limits
      limits: {
        // trackedAsins: 10,
        // searchTerms: 10,
        campaigns: 'unlimited',
        users: 3,
      },
      // Available add-ons
      availableAddOns: ['asin-tracking', 'search-term-tracking'],
    },
    usageMetering: {
      enabled: true,
      baseRate: 0.01, // $0.01 per $1 of ad spend
      description: '$0.01 per $1 of Amazon PPC ad spend',
    },
    callToAction: 'Upgrade to Founders',
    highlight: 'Best Value',
  },

  enterprise: {
    id: 'enterprise',
    name: 'Enterprise',
    description: 'Custom pricing and features for large businesses',
    price: null, // Custom pricing
    billingPeriod: 'custom',
    popular: false,
    type: 'enterprise',
    features: {
      // Core features
      coreFeatures: [
        'Everything in Founders',
        'Unlimited tracked ASINs',
        'Unlimited search terms',
        'All future add-ons included',
        'Dedicated account manager',
        'Custom integrations',
        'Priority phone support',
        'SLA guarantee',
        'Custom reporting',
        'Team collaboration',
        'API access',
      ],
      // Usage limits
      limits: {
        trackedAsins: 'unlimited',
        searchTerms: 'unlimited',
        campaigns: 'unlimited',
        users: 'unlimited',
      },
      // All add-ons included
      includedAddOns: 'all',
    },
    usageMetering: {
      enabled: true,
      baseRate: 'custom', // Negotiated rate
      description: 'Custom usage rates based on volume',
    },
    callToAction: 'Contact Sales',
    highlight: 'Full Feature Access',
  },
};
